import { f7 } from 'framework7-react';
import { useState } from 'react';
import { fetchMAffiliateSettingsApi } from '@/api/infoApi';
import {
  getPrepaidChargeParameter,
  postCreateGmoLinkTypePlusCardParameterApi,
} from '@/api/prepaidApi';
import { paths } from '@/config/paths';
import { store } from '@/config/store';
import { endpoint } from '@/consts/api';
import {
  GmoPaymentUrlGenerationParams,
  GmoPaymentUrlGenerationResponse,
} from '@/types/api/payment';
import { persistGmoLoginContext } from '@/utils/loginTel';
import { paymentStorage } from '@/utils/paymentStorage';
export const useLinkTypePlusChargePrepaid = (previousPage?: string) => {
  const authInfo = store.state.authInfo;
  const displayPayment = store.state.prepaidChargePayment; // 選択された決済方法
  const mAffiliateId = store.state.customerInfo.m_affiliate_id;
  const prepaidsInfo = store.state.advancePaymentsInfo[0];

  const ProcessDate = new Date();

  const [GMOLinkTypePlusParameters, setLinkTypeGMOParameters] = useState<
    GmoPaymentUrlGenerationResponse['data']
  >({
    success: true,
    error: false,
    data: {
      OrderID: '',
      LinkUrl: '',
      ProcessDate: '',
      WarnList: undefined,
    },
  });

  const generateGMOLinkTypePlusParameters = async (amount: number) => {
    if (amount < 0) {
      return;
    }
    try {
      const { data: affiliateData } = await fetchMAffiliateSettingsApi({
        m_affiliate_id: mAffiliateId,
      });

      if (!affiliateData.success) {
        console.log('maffili api failed');
        return;
      }

      const { gmopg_site_id, gmopg_site_pass, gmopg_shop_id, gmopg_shop_pass } =
        affiliateData.data;

      const params = {
        m_payment_method_id: displayPayment.paymentMethodId,
        m_prepaid_id: prepaidsInfo.id,
        m_customer_id: authInfo.m_customer_id,
        amount,
        siteID: gmopg_site_id,
        sitePass: gmopg_site_pass,
        ShopID: gmopg_shop_id,
        ShopPass: gmopg_shop_pass,
      };

      const { data: chargeData } = await getPrepaidChargeParameter(params);

      const { MemberPassString, ShopPassString, DateTime, OrderID, MemberID } =
        chargeData.data;

      const missingParams = [
        !amount && '決済金額',
        !gmopg_site_id && 'サイトID',
        !gmopg_site_pass && 'サイトパス',
        !gmopg_shop_id && 'ショップID',
        !gmopg_shop_pass && 'ショップパス',
        !MemberPassString && '会員情報確認用パス',
        !ShopPassString && 'ショップ情報確認パス',
        !DateTime && '日時情報',
        !OrderID && 'オーダーID',
        !MemberID && '会員ID',
      ].filter((v) => v);

      if (missingParams.length > 0) {
        f7.dialog.alert(
          '',
          `請求情報に不備があります: ${missingParams.join(', ')}`,
        );
        return;
      }

      // GMOからのリダイレクト場所を設定
      const token = authInfo.token;
      const mCustomerId = authInfo.m_customer_id;
      persistGmoLoginContext({
        token,
        customerId: mCustomerId,
        loginInfo: store.state.loginInfo,
      });
      paymentStorage.setItem('destination_step', '2');
      paymentStorage.setItem('destination_page', paths.chargePrepaid);
      paymentStorage.setItem('charge_amount', amount.toString());
      paymentStorage.setItem('m_prepaid_id', prepaidsInfo?.id.toString());

      paymentStorage.setItem('gmopg_site_id', gmopg_site_id.toString()); // サイトID
      paymentStorage.setItem('gmopg_shop_id', gmopg_shop_id.toString()); // ショップID
      paymentStorage.setItem('OrderID', OrderID.toString()); // 注文ID
      paymentStorage.setItem('DateTime', DateTime.toString()); // 現在日時
      // window.localStorage.setItem('ErrCode', ErrCode.toString()); // エラーコード
      // window.localStorage.setItem('ErrDetail', ErrDetail.toString()); // エラー詳細
      // window.localStorage.setItem('CheckString', CheckString.toString()); // チェック文字列
      // window.localStorage.setItem('SaveCard', SaveCard.toString()); // カード保存フラグ
      // window.localStorage.setItem('HolderName', HolderName.toString()); // カード名義人
      // window.localStorage.setItem('CardNo', CardNo.toString()); // クレジットカード番号
      paymentStorage.setItem('MemberID', MemberID.toString()); // 会員ID

      // Service checkouts must resume their saved reservation, not the wallet.
      const serviceReturn =
        previousPage === 'car_wash_hand'
          ? paths.carWashHandStatus
          : previousPage === 'car_wash_conditioner'
          ? paths.carWashConditionerStatus
          : undefined;
      const completePath = serviceReturn
        ? serviceReturn('gmo_success')
        : '/prepaid/charge_prepaid_success/';
      const cancelPath = serviceReturn
        ? serviceReturn('gmo_cancel')
        : '/prepaid/charge_prepaid_cancel/';
      const createGmoParams: GmoPaymentUrlGenerationParams = {
        m_affiliate_id: mAffiliateId.toString(),
        m_customer_id: mCustomerId.toString(),
        config_id: '1',
        order_id: OrderID,
        amount: amount.toString(),
        complete_url: `${endpoint.BASE_URL}${completePath}`,
        cancel_url: `${endpoint.BASE_URL}${cancelPath}`,
        member_id: MemberID,

        // complete_url: `https://localhost:3003/v1/gmo-payment/cardresult/${
        //   previousPage || 'charge_prepaid'
        // }`,
        // cancel_url: `https://localhost:3003/${
        //   previousPage || 'prepaid'
        // }/charge_prepaid_cancel/`,
      };

      const res = await postCreateGmoLinkTypePlusCardParameterApi(
        createGmoParams,
      );
      setLinkTypeGMOParameters(res.data);
      if (res.data.success && 'LinkUrl' in res.data.data) {
      }
      return res.data;
    } catch (error) {
      console.error('GMOパラメータの生成に失敗しました', error);
    }
  };

  return {
    GMOLinkTypePlusParameters,
    generateGMOLinkTypePlusParameters,
  };
};
